import { useQuery } from '@tanstack/react-query';
import { setModulePlanOverrides, type Plan } from '@kontor/shared';
import { api } from './api';

interface Meta {
  version?: string;
  modulePlanOverrides?: Partial<Record<string, Plan | null>>;
}

/**
 * Angaben des Servers (GET /meta). Mit der Antwort bekommt das gemeinsame Paket die Zuordnung der Module zu den Paketen, die der Betreiber eingestellt hat. Alle Funktionen
 * wie `modulesForPlan` oder `planChange` rechnen danach mit dieser Zuordnung und nicht mit der Standardzuordnung aus dem Code.
 * Wer Pakete und ihre Module anzeigt, ruft diesen Hook auf, damit die Seite nach dem Laden neu rechnet.
 */
export function useMeta() {
  return useQuery({
    queryKey: ['meta'],
    queryFn: async () => {
      const data = (await api<{ data: Meta }>('GET', '/meta')).data;
      setModulePlanOverrides(data.modulePlanOverrides ?? {});
      return data;
    },
    staleTime: 60_000,
  });
}
